// ISO 3166-1 alpha-2 → name, for the billing-details country select (tax is
// computed from it on the server side, so it is required).
export const COUNTRIES = [
    ['AF', 'Afghanistan'],
    ['AL', 'Albania'],
    ['DZ', 'Algeria'],
    ['AD', 'Andorra'],
    ['AO', 'Angola'],
    ['AR', 'Argentina'],
    ['AM', 'Armenia'],
    ['AU', 'Australia'],
    ['AT', 'Austria'],
    ['AZ', 'Azerbaijan'],
    ['BH', 'Bahrain'],
    ['BD', 'Bangladesh'],
    ['BY', 'Belarus'],
    ['BE', 'Belgium'],
    ['BZ', 'Belize'],
    ['BJ', 'Benin'],
    ['BO', 'Bolivia'],
    ['BA', 'Bosnia and Herzegovina'],
    ['BW', 'Botswana'],
    ['BR', 'Brazil'],
    ['BN', 'Brunei'],
    ['BG', 'Bulgaria'],
    ['KH', 'Cambodia'],
    ['CM', 'Cameroon'],
    ['CA', 'Canada'],
    ['CL', 'Chile'],
    ['CN', 'China'],
    ['CO', 'Colombia'],
    ['CR', 'Costa Rica'],
    ['HR', 'Croatia'],
    ['CY', 'Cyprus'],
    ['CZ', 'Czechia'],
    ['DK', 'Denmark'],
    ['DO', 'Dominican Republic'],
    ['EC', 'Ecuador'],
    ['EG', 'Egypt'],
    ['SV', 'El Salvador'],
    ['EE', 'Estonia'],
    ['ET', 'Ethiopia'],
    ['FI', 'Finland'],
    ['FR', 'France'],
    ['GE', 'Georgia'],
    ['DE', 'Germany'],
    ['GH', 'Ghana'],
    ['GR', 'Greece'],
    ['GT', 'Guatemala'],
    ['HN', 'Honduras'],
    ['HK', 'Hong Kong'],
    ['HU', 'Hungary'],
    ['IS', 'Iceland'],
    ['IN', 'India'],
    ['ID', 'Indonesia'],
    ['IE', 'Ireland'],
    ['IL', 'Israel'],
    ['IT', 'Italy'],
    ['JM', 'Jamaica'],
    ['JP', 'Japan'],
    ['JO', 'Jordan'],
    ['KZ', 'Kazakhstan'],
    ['KE', 'Kenya'],
    ['KR', 'South Korea'],
    ['KW', 'Kuwait'],
    ['KG', 'Kyrgyzstan'],
    ['LV', 'Latvia'],
    ['LB', 'Lebanon'],
    ['LI', 'Liechtenstein'],
    ['LT', 'Lithuania'],
    ['LU', 'Luxembourg'],
    ['MO', 'Macao'],
    ['MY', 'Malaysia'],
    ['MT', 'Malta'],
    ['MU', 'Mauritius'],
    ['MX', 'Mexico'],
    ['MD', 'Moldova'],
    ['MC', 'Monaco'],
    ['MN', 'Mongolia'],
    ['ME', 'Montenegro'],
    ['MA', 'Morocco'],
    ['MZ', 'Mozambique'],
    ['NA', 'Namibia'],
    ['NP', 'Nepal'],
    ['NL', 'Netherlands'],
    ['NZ', 'New Zealand'],
    ['NI', 'Nicaragua'],
    ['NG', 'Nigeria'],
    ['MK', 'North Macedonia'],
    ['NO', 'Norway'],
    ['OM', 'Oman'],
    ['PK', 'Pakistan'],
    ['PA', 'Panama'],
    ['PY', 'Paraguay'],
    ['PE', 'Peru'],
    ['PH', 'Philippines'],
    ['PL', 'Poland'],
    ['PT', 'Portugal'],
    ['QA', 'Qatar'],
    ['RO', 'Romania'],
    ['RW', 'Rwanda'],
    ['SA', 'Saudi Arabia'],
    ['SN', 'Senegal'],
    ['RS', 'Serbia'],
    ['SG', 'Singapore'],
    ['SK', 'Slovakia'],
    ['SI', 'Slovenia'],
    ['ZA', 'South Africa'],
    ['ES', 'Spain'],
    ['LK', 'Sri Lanka'],
    ['SE', 'Sweden'],
    ['CH', 'Switzerland'],
    ['TW', 'Taiwan'],
    ['TZ', 'Tanzania'],
    ['TH', 'Thailand'],
    ['TN', 'Tunisia'],
    ['TR', 'Türkiye'],
    ['UG', 'Uganda'],
    ['UA', 'Ukraine'],
    ['AE', 'United Arab Emirates'],
    ['GB', 'United Kingdom'],
    ['US', 'United States'],
    ['UY', 'Uruguay'],
    ['UZ', 'Uzbekistan'],
    ['VE', 'Venezuela'],
    ['VN', 'Vietnam'],
    ['ZM', 'Zambia'],
    ['ZW', 'Zimbabwe'],
]

export function countryName(code) {
    const country = COUNTRIES.find(([known]) => known === code)
    return country ? country[1] : code
}
